// import '../popular-dtc.css'
import * as React from "react"
import Card from 'react-bootstrap/Card';
import { Stack, Button } from "react-bootstrap"
import { ethers } from 'ethers'
import '../../pages/styles/index.scss'
import './dtc.css'
import ReactPlayer from 'react-player'

const Dtc = ({ src, name, price, sendTo }) => {

    // const [modalShow, setModalShow] = React.useState(false);
    const [video, setVideo] = React.useState(false)

    const isVideo = async () => {
        var req = await fetch(src, { method: 'HEAD' });
        if (req.headers.get('content-type') === 'video/mp4') {
            setVideo(true);

        } else {
            setVideo(false)
        }
    }
    React.useEffect(() => {
        isVideo();
    }, [src])


    return (
        <Card className='dtc-card'>
            <figure className="card-figure-top">
                <a href={sendTo}>
                    {!video ?
                        (<Card.Img variant="top" alt="Logo" src={src} />)
                        :
                        (
                            <ReactPlayer
                                url={src}
                                muted={true}
                                loop={true}
                                playing={true}
                            />
                            // ReactPlayer
                            // <iframe title='videoUrl'  src={src + "?autoplay=1"}>
                            // </iframe>
                        )
                    }
                </a>
            </figure>
            <Card.Body>
                <a href={sendTo}><Card.Title className='title-700'>{name}</Card.Title></a>
                <div className='texts-button'>
                    <h6 className='title-500'>{ethers.utils.formatEther(price)} USD</h6>
                    <Button className='background-buttons-home' href={sendTo} variant="primary">Buy Now</Button>
                </div>
            </Card.Body>
        </Card>
    );
}
export default Dtc;